import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AdminGuard from './components/Guards/AdminGuard';
import { isElectron } from './utils/electron';

const Video = lazy(() => import('./pages/Video'));
const OauthCallback = lazy(() => import('./pages/OauthCallback'));
const DownloadPage = lazy(() => import('./pages/Download'));


const routes: RouteObject[] = [
    { path: '/', element: <Video /> },
    { path: '/oauth', element: <OauthCallback /> },
    { path: '/download', element: <DownloadPage /> }
];





if (!isElectron()) {
    const Workflow= lazy(() => import('./pages/Admin/Workflow'));
    const JobList = lazy(() => import('./pages/Admin/JobList'));
    const BullJobList = lazy(() => import('./pages/Admin/BullJobList'));
    const Users = lazy(() => import('./pages/Admin/Users'));
    const Models = lazy(() => import('./pages/Admin/Models'));
    const Settings = lazy(() => import('./pages/Admin/Settings'));

    const adminRoutes: RouteObject[] = [{
        element: <AdminGuard />,
        children: [
            { path: '/admin/jobs', element: <JobList /> },
            { path: '/admin/bulljobs', element: <BullJobList /> },
            { path: '/admin/users', element: <Users /> },
            { path: '/admin/workflow', element: <Workflow /> },
            { path: '/admin/models', element: <Models /> },
            {path: '/admin/settings', element: <Settings />}
        ]
    }]

    routes.push(...adminRoutes);
}


export default routes;
